import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Typography from "@mui/material/Typography";
import { Dialog } from "~components/shared/Dialog/Dialog.tsx";
import { useTranslation } from "~contexts/I18nContext/I18nContext.tsx";
import { subTranslationVars } from "~lib/stringHelpers.ts";
import { BusinessWarningIcon } from "./BusinessWarningIcon.tsx";

export type ForeignTenantToolWarningData = {
  toolDisplayName: string;
  tenantName: string;
  onConfirm: () => void;
};

type ForeignTenantToolWarningDialogProps = {
  isModalOpen: boolean;
  onClose: () => void;
  data: ForeignTenantToolWarningData | null;
};

export function ForeignTenantToolWarningDialog({
  isModalOpen,
  onClose,
  data,
}: ForeignTenantToolWarningDialogProps) {
  const t = useTranslation();

  const message = data
    ? subTranslationVars(
        t.foreignTenantToolWarningMessage,
        {
          toolDisplayName: data.toolDisplayName,
          tenantName: data.tenantName,
        },
        { escapeHtml: true },
      )
    : "";

  const handleConfirm = () => {
    data?.onConfirm();
    onClose();
  };

  return (
    <Dialog
      dialogTitle={t.foreignTenantToolWarningTitle}
      icon={<BusinessWarningIcon />}
      open={isModalOpen}
      onClose={onClose}
      isCancelable
    >
      <DialogContent>
        {/* biome-ignore lint/security/noDangerouslySetInnerHtml: interpolated values HTML-escaped via subTranslationVars */}
        <Typography dangerouslySetInnerHTML={{ __html: message }} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} type="button">
          {t.cancel}
        </Button>
        <Button variant="contained" color="primary" onClick={handleConfirm}>
          {t.foreignTenantToolWarningConfirm}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
